import { useEffect, useRef, useState } from 'react';
import { Grid } from '@mui/material';
import { isEnvTypePROD } from '../../service/config';
import '../TableauObs/Summary/Summary.scss';
import moment from 'moment';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
	dataEstateExecutiveSummary,
	dataEstateOverallSummary,
	fetchAnnualSpendDataSourceIncidents,
	fetchAzureMonthlyCost,
	fetchDEStorageSummary,
	fetchDatabricksClustersCount,
	getDataEstateSector,
	getOverviewSummaryMetrics,
	getOverviewSummaryCost,
	getDataEstateKpiSector,
	fetchTableauSummary,
	fetchDEPowerBIUserAndReport
} from '../../service/service';
import '../DataEstate/data-estate.scss';
import ArrowIcon from '../../assets/Arrow 253.svg';
import DashboardIcon from '../../assets/material-symbols_dashboard.svg';
import ArrowIconRed from '../../assets/growth arrow down.svg';
import ArrowIconUpRed from '../../assets/growth arrow up_red.svg';
import ArrowIconDownGreen from '../../assets/growth arrow down_green.svg';
import NumberWidget from '../Widgets/NumberWidget';
import { renderTooltipIcon } from '../TableauObs/common/KpiCard';
import WidgetCardContainer from 'components/Widgets/WidgetCardContainer';
import { getPercentageOfTwoNumbers, formatNumberWithCommas, convertDecimalToTime } from '../../utils/common-util';
import useDataEstateSideDrawer from './SideDrawers/useDrawerComponent';
import { useCacheDataController } from 'Context/contexts/CacheDataContext';
import { MetricDetails, sectorListDetails } from 'Context/contexts/cacheData/DataEstate/type';
import {
	setDataBricksClusters,
	setDEStorageSummary,
	setExecutiveMetricDetails,
	setMetricDetails,
	setOverviewMetrics,
	setPowerBiUserCount,
	setTableauPrevUserCount,
	setTableauUserCount,
	setTeradataDetails,
	setPowerbiUsageCount,
	setPowerBIPreviousUsageCount,
	setCostYTD
} from 'Context/contexts/cacheData/DataEstate';
import { getCurrentAndPreviousMonthNames } from '../../utils/currentAndPreviousmonth'
import PageHeader from 'components/Header/Page';
import SectorFilter from 'components/Dropdown/SectorFilter';
import PageWrapper from 'components/Common/PageWraper';
import HighlightedText from 'components/GlobalSearch/HighlightText';

const OverallSummary = () => {
	const navigate = useNavigate();
	const { handleSetComponent } = useDataEstateSideDrawer();
	const [searchParams] = useSearchParams();
	const [sectorName, setSectorName] = useState('all');
	const hasDrillDown = searchParams.has('isDrillDowned');
	const [tableauUsersGrowth, setTableauUsersGrowth] = useState(0);
	const [, setPowerBiGrowth] = useState(0);
	const [powerbiUsageGrowth, setPowerbiUsageGrowth] = useState(0);

	// sector filter
	const [sectorOptionsList, setSectorOptionsList] = useState<any[]>([]);
	const [, setCheckedList] = useState<any[]>([]);
	const [, setCurrSectorFilter] = useState<any[]>([]);
	const [sector] = useState<any[]>([]);
	const dataFetchedRef = useRef(false);

	const [controller, dispatch] = useCacheDataController();
	const {
		metricDetails,
		executiveMetricDetails,
		databricksClusters,
		deStorageSummary,
		overviewMetrics,
		tableauUserCount,
		tableauPrevUserCount,
		powerBiUserCount,
		teraDataJobs,
		teraDataGrowthSize,
		teraDataSize,
		teraDataPrevSize,
		powerbiUsageCount,
		powerBiPrevUserCount,
		costYTD
	} = controller;

	const [allSectorOptionsList, setAllSectorOptionsList] = useState<sectorListDetails | null>(null);
	const [sectorTagList, setSectorTagList] = useState<any>({ azure: true, majorInc: true, datapipeline: true, databricks: true, tableauUser: true, tableauUserGrowth: true, costytdSpend: true, avgMonthlycost: true });

	const [allSectorMetricsData] = useState(() => {
		const sectorData = localStorage.getItem('metricDetails');
		return sectorData ? JSON.parse(sectorData) : null;
	});

	const [allSectorExecutiveData, setAllSectorExecutiveData] = useState(() => {
		const sectorData = localStorage.getItem('executiveDetails');
		return sectorData ? JSON.parse(sectorData) : null;
	});

	const { currentMonth, previousMonth } = getCurrentAndPreviousMonthNames();

	const [loading, setLoading] = useState(false);
	const [executiveLoading, setExecutiveLoading] = useState(false);
	const [OutageDuration, setOutageDuration] = useState<any>(null);
	const [, setAzureMonthlyCostDetails] = useState<MetricDetails | null>(null);

	const handleNavigateIncident = () => {
		navigate('/dataestate/majorIncident');
	};

	const handleNavigateCost = () => {
		navigate('/dataestate/costSummary');
	};


	const handleDeStorageData = (data: any) => {
		let teradataSize = data?.dataStoredInTeradata?.[0]?.['VALUE'] ?? 0;
		let teradataPrevSize = data?.dataStoredInTeradataPrev?.[0]?.['VALUE'] ?? 0;
		setTeradataDetails(dispatch, teradataPrevSize, 'TERADATA_PREV_SIZE');
		setTeradataDetails(dispatch, teradataSize, 'TERADATA_SIZE');

		if (teradataPrevSize) {
			setTeradataDetails(dispatch, getPercentageOfTwoNumbers(teradataPrevSize, teradataSize), 'TERADATA_GROWTH_SIZE');
		}
	};

	async function fetchDEStorageSummaryFunc(sector: any) {
		if ((sector != '') || (deStorageSummary === null)) {
			setTeradataDetails(dispatch, null, 'TERADATA_PREV_SIZE');
			setTeradataDetails(dispatch, null, 'TERADATA_SIZE');
			if (sector == 'Blank') {
				sector = ''
			}
			fetchDEStorageSummary(sector, '0M')
				.then((res) => {
					setDEStorageSummary(dispatch, res.data);
					handleDeStorageData(res.data);
				})
				.catch((error) => {
					console.error(error);
				});
		} else {
			handleDeStorageData(deStorageSummary);
		}
	}

	async function loadDatabricksClustersCount() {
		if (databricksClusters === null) {
			setLoading(true);
			try {
				const res = await fetchDatabricksClustersCount('', '', true, 'overallDatabrickscluster');
				if (res.success) {
					let count = res.data.databricksClustersCount.length ?
						res.data.databricksClustersCount[0].ClusterCount : 0;
					setDataBricksClusters(dispatch, count);
				}
				setLoading(false);
			} catch (error) {
				setLoading(false);
			}
		}
	}

	async function dataestateOverallSummaryFunc(sector: any) {
		if ((sector != '') || (metricDetails === null)) {
			setMetricDetails(dispatch, null);
			setLoading(true);
			try {
				if (sector == 'Blank') {
					sector = ''
				}
				const res = await dataEstateOverallSummary(sector);
				if (res.success) {
					setMetricDetails(dispatch, res.data);
					if (sector == 'all') {
						localStorage.setItem('metricDetails', JSON.stringify(res.data));
					}
					// setPowerBiGrowth(res.data.activeReports / 1000);
					// hardcodded 0 as by Pepsico
					setPowerBiGrowth(0);
					fetchAnnualSpendDataSourceIncidents('teradata-jobs', '0M', [])
						.then((res) => {
							setTeradataDetails(dispatch, res?.data?.result[0]?.count ?? 0, 'TERADATA_JOBS');
						})
						.catch((error) => {
							console.error(error);
						});
				}
				setLoading(false);
			} catch (error) {
				setLoading(false);
			}
		}
	}

	async function dataestateExecutiveSummaryFunc(sector: any) {
		if ((sector != '') || (executiveMetricDetails === null)) {
			setExecutiveLoading(true);
			try {
				if (sector == 'Blank') {
					sector = ''
				}
				const res = await dataEstateExecutiveSummary(sector);
				if (res.success) {
					if (sector == 'all') {
						localStorage.setItem('executiveDetails', JSON.stringify(res.data));
					}
					setExecutiveMetricDetails(dispatch, res.data);
					setOutageDuration(convertDecimalToTime(res.data.outageDuration));
				}
				setExecutiveLoading(false);
			} catch (error) {
				setExecutiveLoading(false);
			}
		} else {
			setOutageDuration(convertDecimalToTime(executiveMetricDetails.outageDuration));
		}
	}

	async function dataestateAzureMonthlyCostFunc() {
		setExecutiveLoading(true);
		try {
			const res = await fetchAzureMonthlyCost();
			if (res.success) {
				setAzureMonthlyCostDetails(res.data);
			}
			setExecutiveLoading(false);
		} catch (error) {
			setExecutiveLoading(false);
		}
	}

	async function getOverviewSummaryMetricsFunc() {
		if (overviewMetrics === null) {
			setLoading(true);
			try {
				const res = await getOverviewSummaryMetrics();
				if (res.success) {
					setOverviewMetrics(dispatch, res.data[0]);
				}
				setLoading(false);
			} catch (error) {
				setLoading(false);
			}
		}
	}

	async function getOverviewSummaryCostFunc() {
		if (overviewMetrics === null) {
			setLoading(true);
			try {
				const res = await getOverviewSummaryCost();
				if (res.success) {
					let count = res.data[0].cost;
					setCostYTD(dispatch, (count / 1000000).toFixed(2));
				}
				setLoading(false);
			} catch (error) {
				setLoading(false);
			}
		}
	}


	async function getTableauUserCount() {
		if (tableauUserCount === null || tableauPrevUserCount === null) {
			setLoading(true);
			try {
				const res = await fetchTableauSummary('', '0M', moment().format());

				if (res.success) {
					let count = res?.data?.result?.tableauUserCount;
					const previousData = await fetchTableauSummary('', '1M', moment().format());
					let previousCount = previousData?.data?.result?.tableauUserCount;
					setTableauUserCount(dispatch, count);
					setTableauPrevUserCount(dispatch, previousCount);
					setTableauUsersGrowth(((count - previousCount) / previousCount) * 100);
				}
				setLoading(false);
			} catch (error) {
				setLoading(false);
			}
		} else {
			setTableauUsersGrowth(((tableauUserCount - tableauPrevUserCount) / tableauPrevUserCount) * 100);
		}
	}

	async function getPowerBIUsageCount() {
		if (powerbiUsageCount === null || powerBiPrevUserCount === null) {
			setLoading(true);
			try {
				const res = await fetchDEPowerBIUserAndReport(sector, 'userCount', 0);

				if (res.success) {
					const values = Object.values(res?.data || []);
					const count = Number(values.at(-1)) || 0;
					const previousData = await fetchDEPowerBIUserAndReport(sector, 'userCount', 1);
					const previousValues = Object.values(previousData?.data || []);
					const previousCount = Number(previousValues.at(-1)) || 0;
					setPowerBiUserCount(dispatch, (count / 1000).toFixed(2));
					setPowerbiUsageCount(dispatch, count);
					setPowerBIPreviousUsageCount(dispatch, previousCount);
					setPowerbiUsageGrowth(((count - previousCount) / previousCount) * 100);
				}
				setLoading(false);
			} catch (error) {
				setLoading(false);
			}
		} else {
			setPowerbiUsageGrowth(((powerbiUsageCount - powerBiPrevUserCount) / powerBiPrevUserCount) * 100);
		}
	}

	async function fetchSectorOptionsData() {
		let sectorKpi = [];
		sectorKpi.push("azure", "majorInc", "datapipeline", "databricks", "tableauUser", "ytdSpend", "avgMonthlycost");
		const sectorRes = await getDataEstateKpiSector(sectorKpi);
		if (sectorRes.success) {
			if (sectorRes.data) {
				setAllSectorOptionsList(sectorRes.data);
			}
		}
		const sectorKpiRes = await getDataEstateSector();
		if (sectorKpiRes.success) {
			if (sectorKpiRes.data) {
				const sectorValues = sectorKpiRes.data.map((item: { sector: any; }) => item.sector);
				const uniqueSectors = Array.from(new Set(sectorValues));
				const sectorNameList: string[] = uniqueSectors.map(sector =>
					(sector === "" || sector === null || sector === undefined) ? "Blank" : String(sector)
				);
				const sortedSectors = [...sectorNameList].sort((a, b) => a.localeCompare(b));
				setSectorOptionsList(sortedSectors);
			}
		}
	}

	useEffect(() => {
		if (!loading) dataestateOverallSummaryFunc('all');
		dataestateExecutiveSummaryFunc('all');
		fetchDEStorageSummaryFunc('all');
		loadDatabricksClustersCount();
		fetchSectorOptionsData();

		// // Summary APIs

		if (hasDrillDown) {
			const selectedSector = localStorage.getItem('selectedSector');
			if (selectedSector) {
				const selectedSec = JSON.parse(selectedSector).length ? JSON.parse(selectedSector) : '';
				setCheckedList(selectedSec);
				setCurrSectorFilter(selectedSec);
			}
		} else {
			localStorage.removeItem('selectedSector');
		}

		if (dataFetchedRef.current) return;
		dataFetchedRef.current = true;
		const activeId = document.getElementById('root');
		if (window.location.pathname === '/dataestate/executive-summary') {
			if (activeId) {
				document.head.classList.add('theme-bg-blue');
				document.body.classList.add('theme-bg-blue');
				activeId.classList.add('jobs-list-table');
				activeId.classList.remove('jobs-list');
				activeId.classList.remove('root');
				document.body.classList.add('jobs-exe-datas');
				document.body.classList.remove('jobs-run-table');
				document.body.classList.add('jobs-list-datas');
				document.body.classList.add('datefilter-align-sector');
				document.body.classList.add('sector-label');
			}
		} else {
			if (activeId) {
				document.body.classList.remove('jobs-list-datas');
				activeId.classList.add('root');
				document.body.classList.add('dashboard-panel-dataestate');
				document.body.classList.add('datefilter-align-sector');
			}
		}
		//Metrics
		getOverviewSummaryMetricsFunc();
		getTableauUserCount();
		getPowerBIUsageCount();
		getOverviewSummaryCostFunc();

		if (allSectorExecutiveData?.outageDuration) {
			const updatedData = {
				...allSectorExecutiveData,
				outageDuration: convertDecimalToTime(allSectorExecutiveData.outageDuration)
			};
			setAllSectorExecutiveData(updatedData);
		}

	}, []);

	const metricDetailsOverSize: number =
		metricDetails === null || metricDetails.overallGrowth === null
			? 0
			: metricDetails.overallGrowth + (teraDataGrowthSize ?? 0);

	const checkBothTeradataAzureApis = () => {
		if (metricDetails !== null && teraDataSize !== null) {
			return false;
		} else
			return true;
	}

	const checkBothTeradataADFApis = () => {
		if (metricDetails !== null && teraDataSize !== null) {
			return false;
		} else
			return true;
	}

	const handleSectorChange = (value: string) => {
		setLoading(true);
		setSectorName(value);
		sectorTagUpdatefun(value);
	};

	const sectorTagUpdatefun = (sector: string) => {
		if (sector != 'all') {
			if (sector == 'Blank')
				sector = '';

			const isInAzure = allSectorOptionsList?.azure.some(item => item.sector === sector);
			const isInSnow = allSectorOptionsList?.majorInc.some(item => item.sector === sector);
			const isIndatapipeline = allSectorOptionsList?.datapipeline.some(item => item.sector === sector);
			const isIndatabricks = allSectorOptionsList?.databricks.some(item => item.sector === sector);
			const isInTableauUser = allSectorOptionsList?.tableauUser.some(item => item.sector === sector);
			const isInTableauUserGrowth = allSectorOptionsList?.tableauUser.some(item => item.sector === sector);
			const isInCostYTDSpend = allSectorOptionsList?.databricks.some(item => item.sector === sector);
			const isInCostAvgMonthly = allSectorOptionsList?.databricks.some(item => item.sector === sector);
			const filteredData = {
				azure: isInAzure || false,
				datapipeline: isIndatapipeline || false,
				majorInc: isInSnow || false,
				databricks: isIndatabricks || false,
				tableauUser: isInTableauUser || false,
				tableauUserGrowth: isInTableauUserGrowth || false,
				costytdSpend: isInCostYTDSpend || false,
				costAvgMonthlySpend: isInCostAvgMonthly || false
			};
			setSectorTagList(filteredData);
			if (filteredData.azure) dataestateOverallSummaryFunc(filteredData.azure ? sector : 'all');
			if (filteredData.majorInc) dataestateExecutiveSummaryFunc(filteredData.majorInc ? sector : 'all');
			if (filteredData.azure) fetchDEStorageSummaryFunc(filteredData.azure ? sector : 'all')
		} else {
			const filteredData = {
				azure: true,
				datapipeline: true,
				majorInc: true,
				databricks: true,
				tableauUser: true,
				tableauUserGrowth: true,
				costytdSpend: true,
				costAvgMonthlySpend: true
			};
			setSectorTagList(filteredData);
			dataestateOverallSummaryFunc(sector);
			dataestateExecutiveSummaryFunc(sector);
		}
	}

	const getGrowthColor = (growth: number | null, isInverse = false) => {
		if (growth === null || growth === 0 || formatNumberWithCommas(growth.toFixed(2), true) === '0.00') {
			return '#000000';
		}
		const isPositive = growth > 0;
		if (isInverse) {
			return isPositive ? 'error.main' : 'success.main';
		}
		return isPositive ? 'success.main' : 'error.main';
	};

	const getGrowthIcon = (growth: number | null, upIcon: any, downIcon: any) => {
		if (growth === null || growth === 0 || formatNumberWithCommas(growth.toFixed(2), true) === '0.00') {
			return null;
		}
		return growth > 0 ? upIcon : downIcon;
	};

	const getSectorLabel = (tagKey: string) => (sectorTagList?.[tagKey] && sectorName !== 'all' ? sectorName : '');

	const dataStoredNumber = sectorTagList?.azure
		? metricDetails && metricDetails !== null
			? formatNumberWithCommas((metricDetails.dataStoredDA + (teraDataSize ?? 0)).toFixed(2), true)
			: 0
		: formatNumberWithCommas((allSectorMetricsData?.dataStoredDA + (teraDataSize ?? 0)).toFixed(2), true);

	const dataTrendNumber = sectorTagList?.azure
		? metricDetails === null
			? 0
			: formatNumberWithCommas(metricDetailsOverSize.toFixed(2), true)
		: formatNumberWithCommas((allSectorMetricsData?.overallGrowth + (teraDataGrowthSize ?? 0)).toFixed(2), true);

	const adfTeradataJobsNumber = !sectorTagList?.datapipeline
		? formatNumberWithCommas((allSectorMetricsData?.dataPipelineCount + teraDataJobs) / 1000, true)
		: metricDetails !== null && teraDataJobs !== null
			? formatNumberWithCommas((metricDetails.dataPipelineCount + teraDataJobs) / 1000, true)
			: 0;

	return (
		<PageWrapper sx={{ mt: { xs: '70px', sm: '50px', md: '30px' } }}>
			<PageHeader title="Executive Summary" icon={DashboardIcon} lastSync={'Today'} headerSx={{ top: '79px', paddingTop: '10px' }} >
				{/* <SectorFilter
					sectorName={sectorName}
					setSectorName={setSectorName}
					sectorOptionsList={sectorOptionsList}
					handleChange={handleSectorChange}
				/> */}
			</PageHeader>
			<Grid container spacing={6} marginTop={'1px'}>
				{/* Row 1: Size (20%), Cost (60%), Processing (20%) */}
				<Grid container item xs={12} sm={12} lg={3} xl={3}>
					<WidgetCardContainer bgColor='#E4EDFF' title="Size" titleSx={{fontSize:"24px"}}>
						<Grid item xs={12} display="flex" id="data-stored">
							<NumberWidget
								title={<HighlightedText text="Data Stored" />}
								tooltipLabel="Data Stored Across D&AI Platforms (All environments) and Teradata (Prod)"
								renderTooltip={(label) => renderTooltipIcon(label, 'light')}
								number={dataStoredNumber}
								bgColor='#ffffff'
								color='#000000'
								valueFontWeight={300}
								sameDecimalSize={true}
								isLoading={checkBothTeradataAzureApis()}
								footer={{
									footerLabel: 'Click to look at Data Storage breakdown',
									footerLink: '/dataestate/storagesummary'
								}}
								units="PB"
								// handleEvent={handleNavigateStorage}
								handleEvent={() =>
									handleSetComponent('DAI_PLATEFORMS', {
										title: 'Data Stored',
										sector: [],
										selectedDate: '2023-01'
									})
								}
								sectorLabel={getSectorLabel('azure')}
							/>
						</Grid>
						<Grid item xs={12} display="flex" id="data-trend">
							<NumberWidget
								title={<HighlightedText text="Data Trend" />}
								tooltipLabel={
									metricDetails && teraDataSize
										? `Month over month data growth across D&AI platforms and Teradata PROD. (${moment().format(
											"MMM 'YY"
										)} - Azure: ${formatNumberWithCommas(
											metricDetails.dataStoredDA.toFixed(2),
											true
										)} PB Teradata: ${formatNumberWithCommas(teraDataSize.toFixed(2), true)} PB & ${moment()
											.subtract(1, 'months')
											.format("MMM 'YY")} - Azure: ${formatNumberWithCommas(
												metricDetails.storagePrevMonCount.toFixed(2)
											)} PB Teradata: ${teraDataPrevSize?.toFixed(2)} PB)`
										: ''
								}
								renderTooltip={(label) => renderTooltipIcon(label, 'light')}
								number={dataTrendNumber}
								bgColor='#ffffff'
								valueFontWeight={300}
								sameDecimalSize={true}
								isLoading={checkBothTeradataAzureApis()}
								footer={{
									footerLabel: 'Click to look at Data Storage breakdown',
									footerLink: '/dataestate/storagesummary'
								}}
								units="%"
								handleEvent={() =>
									handleSetComponent('OVERALL_DATA_GROWTH', {
										title: 'Data Trend',
										sector: [],
										selectedDate: '0M'
									})
								}
								sectorLabel={getSectorLabel('azure')}
								// bgColor={
								// 	!!metricDetails &&
								// 	!!metricDetailsOverSize &&
								// 	formatNumberWithCommas(metricDetailsOverSize.toFixed(2), true) !== '0.00'
								// 		? metricDetailsOverSize > 0
								// 			? 'error.main'
								// 			: 'success.main'
								// 		: undefined
								// }
								// unitIcon={
								// 	!!metricDetails &&
								// 	!!metricDetailsOverSize &&
								// 	formatNumberWithCommas(metricDetailsOverSize.toFixed(2), true) !== '0.00'
								// 		? metricDetailsOverSize > 0
								// 			? ArrowUp
								// 			: ArrowDown
								// 		: null
								// }
								color={getGrowthColor(metricDetailsOverSize, true)}
								unitIcon={getGrowthIcon(metricDetailsOverSize, ArrowIconUpRed, ArrowIconDownGreen)}
							/>
						</Grid>
					</WidgetCardContainer>
				</Grid>

				<Grid container item xs={12} sm={12} lg={6} xl={6}>
					<WidgetCardContainer bgColor='#E4EDFF' title="Cost" titleSx={{fontSize:"24px"}}>
						<Grid item xs={12} sm={6} display="flex" id="ytd-spend">
							<NumberWidget
								isCost
								bgColor='#ffffff'
								color='#000000'
								valueFontWeight={300}
								sameDecimalSize={true}
								title={<HighlightedText text="YTD Spend" />}
								tooltipLabel="Total D&AI platform cost (Azure, Databricks and Teradata)"
								renderTooltip={(label) => renderTooltipIcon(label, 'light')}
								number={
									costYTD ? costYTD : '0'
								}
								units="MM"
								isLoading={!overviewMetrics}
								handleEvent={() =>
									handleSetComponent('YTD_SPEND', {
										title: 'YTD Spend',
										sector: [],
										selectedDate: '2023-01'
									})
								}
								sectorLabel={getSectorLabel('costytdSpend')}
							/>
						</Grid>
						<Grid item xs={12} sm={6} display="flex" id="ri-savings">
							<NumberWidget
								isCost
								bgColor='#ffffff'
								color='#000000'
								valueFontWeight={300}
								sameDecimalSize={true}
								title={<HighlightedText text="RI Savings" />}
								tooltipLabel="Year to Date Cost avoidance by using Reserved Instances"
								renderTooltip={(label) => renderTooltipIcon(label, 'light')}
								// number={
								// 	overviewMetrics?.reservedInstanceSavingsYTD
								// 		? formatNumberWithCommas(overviewMetrics?.reservedInstanceSavingsYTD.toFixed(2), true)
								// 		: 0
								// }
								number={
									overviewMetrics?.riSavingsCost ? (overviewMetrics.riSavingsCost / 1000000).toFixed(2) : '0.00'
								}
								units="MM"
								isLoading={!overviewMetrics}
								handleEvent={isEnvTypePROD ? undefined : handleNavigateCost}
							/>
						</Grid>
						<Grid item xs={12} display="flex" id="avg-monthly-trend">
							<NumberWidget
								title={<HighlightedText text="Avg Monthly Cost Trend" />}
								tooltipLabel="Month over month platform cost growth"
								renderTooltip={(label) => renderTooltipIcon(label, 'light')}
								units="%"
								bgColor='#ffffff'
								valueFontWeight={300}
								sameDecimalSize={true}
								number={
									overviewMetrics?.avg_monthly_cost_growth ? overviewMetrics.avg_monthly_cost_growth.toFixed(2) : '0'
								}
								// unitIcon={
								// 	!!overviewMetrics?.avg_monthly_cost_growth &&
								// 	overviewMetrics.avg_monthly_cost_growth.toFixed(2) != '-0' && overviewMetrics.avg_monthly_cost_growth.toFixed(2) != '0'
								// 		? overviewMetrics?.avg_monthly_cost_growth > 0
								// 			? ArrowUp
								// 			: ArrowDown
								// 		: null
								// }
								isLoading={!overviewMetrics}
								// bgColor={
								// 	!!overviewMetrics?.avg_monthly_cost_growth &&
								// 	overviewMetrics.avg_monthly_cost_growth.toFixed(2) != '-0' && overviewMetrics.avg_monthly_cost_growth.toFixed(2) != '0'
								// 		? overviewMetrics?.avg_monthly_cost_growth < 0
								// 			? 'success.main'
								// 			: 'error.main'
								// 		: undefined
								// }
								//Commented as per request by pepsico
								// unitIcon={
								// 	azureMonthlyCostDetails !== null && metricDetailsOverSize !== 0
								// 		? azureMonthlyCostDetails.avgMonthlyCost >= 0
								// 			? ArrowIcon
								// 			: ArrowIconRed
								// 		: null
								// }
								// number={azureMonthlyCostDetails !== null ? azureMonthlyCostDetails.avgMonthlyCost.toFixed(2) : 0}
								// color={
								// 	azureMonthlyCostDetails !== null ? azureMonthlyCostDetails.avgMonthlyCost <= 0
								// 			? 'error.main'
								// 			: 'success.main'
								// 		: 'text.main'
								// }
								// isLoading={!azureMonthlyCostDetails || executiveLoading}
								// isInProgress
								handleEvent={() =>
									handleSetComponent('AVG_MONTHLY_COST_TREND', {
										title: 'Avg Monthly Cost Trend',
										sector: [],
										selectedDate: '2023-01'
									})
								}
								isCost={false}
								unitIcon={getGrowthIcon(overviewMetrics?.avg_monthly_cost_growth ?? null, ArrowIconUpRed, ArrowIconDownGreen)}
								color={getGrowthColor(overviewMetrics?.avg_monthly_cost_growth ?? null, true)}
								sectorLabel={getSectorLabel('avgMonthlycost')}
							/>
						</Grid>
					</WidgetCardContainer>
				</Grid>

				<Grid container item xs={12} sm={12} lg={3} xl={3}>
					<WidgetCardContainer bgColor='#E4EDFF' title={['Processing']} titleSx={{fontSize:"24px"}}>
						<Grid item xs={12} display="flex" id="adf-teradata">
							<NumberWidget
								title={<HighlightedText text="ADF Pipelines & Teradata Jobs" />}
								tooltipLabel="Total data processing pipelines in D&AI across Azure (All environments) and Teradata Jobs (Prod)"
								renderTooltip={(label) => renderTooltipIcon(label, 'light')}
								number={adfTeradataJobsNumber}
								bgColor='#ffffff'
								color='#000000'
								valueFontWeight={300}
								sameDecimalSize={true}
								isLoading={checkBothTeradataADFApis()}
								footer={{
									footerLabel: 'Click to look at processing breakdown',
									footerLink: '/dataestate/data-processing'
								}}
								units="k"
								// handleEvent={handleNavigateDataProcessing}
								handleEvent={() =>
									handleSetComponent('TOTAL_PIPELINES', {
										title: 'ADF Pipelines & Teradata Jobs',
										sector: [],
										selectedDate: '0M'
									})
								}
								sectorLabel={getSectorLabel('datapipeline')}
							// isInProgress
							/>
						</Grid>
						<Grid item xs={12} display="flex" id="dbx-ytd">
							<NumberWidget
								title={<HighlightedText text="Compute Clusters" />}
								tooltipLabel={'Total compute clusters in Databricks (All environments)'}
								renderTooltip={(label) => renderTooltipIcon(label, 'light')}
								number={databricksClusters !== null ? formatNumberWithCommas(databricksClusters / 1000000, true) : 0}
								bgColor='#ffffff'
								color='#000000'
								valueFontWeight={300}
								sameDecimalSize={true}
								isLoading={databricksClusters === null}
								footer={{
									footerLabel: 'Click to look at processing breakdown',
									footerLink: '/dataestate/data-processing'
								}}
								// number={10.18}
								units="MM"
								//handleEvent={handleNavigateDataProcessing}
								handleEvent={() =>
									handleSetComponent('TOTAL_CLUSTER', {
										title: 'Databricks Clusters',
										sector: [],
										selectedDate: '2023-01'
									})
								}
								sectorLabel={getSectorLabel('databricks')}
							// isInProgress
							/>
						</Grid>
					</WidgetCardContainer>
				</Grid>

				{/* Row 2: BI Usage (50%), Sustain YTD (50%) */}
				<Grid container item xs={12} lg={6} xl={6}>
					<WidgetCardContainer bgColor='#E4EDFF' title="BI Usage" titleSx={{fontSize:"24px"}}>
						<Grid item xs={12} sm={6} md={3} xl={6} display="flex" id="pbi">
							<NumberWidget
								title={<HighlightedText text="Power BI" />}
								tooltipLabel="Total Power BI users in Prod"
								renderTooltip={(label) => renderTooltipIcon(label, 'light')}
								number={(powerBiUserCount && powerBiUserCount !== null ? powerBiUserCount : 0).toLocaleString(
									undefined,
									{
										minimumFractionDigits: 0
									}
								)}
								bgColor='#ffffff'
								color='#000000'
								valueFontWeight={300}
								sameDecimalSize={true}
								isLoading={!powerBiUserCount}
								units="k"
								handleEvent={() =>
									handleSetComponent('POWERBI_USERS', {
										title: 'Power BI',
										sector: [],
										selectedDate: '2023-01'
									})
								}
							// isInProgress
							/>
						</Grid>
						<Grid item xs={12} sm={6} md={3} xl={6} display="flex" id="tableau">
							<NumberWidget
								title={<HighlightedText text="Tableau" />}
								tooltipLabel={'Total Tableau users in PROD (Licenses are not included)'}
								renderTooltip={(label) => renderTooltipIcon(label, 'light')}
								number={(tableauUserCount ? (tableauUserCount / 1000).toFixed(2) : 0).toLocaleString(undefined, {
									minimumFractionDigits: 0
								})}
								bgColor='#ffffff'
								color='#000000'
								valueFontWeight={300}
								sameDecimalSize={true}
								isLoading={!tableauUserCount}
								footer={{
									footerLabel: 'Click to look at processing breakdown',
									footerLink: '/dataestate/biApplicationSummary'
								}}
								units="k"
								// handleEvent={handleNavigateBiApps}
								handleEvent={() =>
									handleSetComponent('TABLEAU_USERS', {
										title: 'Tableau',
										sector: [],
										selectedDate: '2023-01'
									})
								}
								sectorLabel={getSectorLabel('tableauUser')}
							/>
						</Grid>
						<Grid item xs={12} sm={6} md={3} xl={6} display="flex" id="pbi-trend">
							<NumberWidget
								title={<HighlightedText text="Power BI Trend" />}
								tooltipLabel={`Month over month usage growth in Power BI - ${currentMonth} Month: ${formatNumberWithCommas(
									powerbiUsageCount
								)} & 
								${previousMonth} Month: ${formatNumberWithCommas(powerBiPrevUserCount)}`}
								renderTooltip={(label) => renderTooltipIcon(label, 'light')}
								// Commented as per request by Pepsico
								// number={metricDetails !== null ? (metricDetails.activeReports / 1000).toFixed(2) : 0}
								bgColor='#ffffff'
								valueFontWeight={300}
								sameDecimalSize={true}
								isLoading={!metricDetails || metricDetails === null}
								number={powerbiUsageGrowth ? formatNumberWithCommas(powerbiUsageGrowth.toFixed(2), true) : 0}
								units="%"
								handleEvent={() =>
									handleSetComponent('POWERBI_USER_GROWTH', {
										title: 'Power BI Trend',
										sector: [],
										selectedDate: '0M'
									})
								}
								// bgColor={
								// 	!!powerbiUsageGrowth && formatNumberWithCommas(powerbiUsageGrowth.toFixed(2), true) !== '0.00'
								// 		? powerbiUsageGrowth > 0
								// 			? 'success.main'
								// 			: 'error.main'
								// 		: undefined
								// }
								// unitIcon={
								// 	!!powerbiUsageGrowth && formatNumberWithCommas(powerbiUsageGrowth.toFixed(2), true) !== '0.00'
								// 		? powerbiUsageGrowth > 0
								// 			? ArrowUp
								// 			: ArrowDown
								// 		: null
								// }
								color={getGrowthColor(powerbiUsageGrowth)}
								unitIcon={getGrowthIcon(powerbiUsageGrowth, ArrowIcon, ArrowIconRed)}
							/>
						</Grid>
						<Grid item xs={12} sm={6} md={3} xl={6} display="flex" id="tableau-trend">
							<NumberWidget
								title={<HighlightedText text="Tableau Trend" />}
								tooltipLabel={`Month over month user growth in Tableau - Current Month: ${formatNumberWithCommas(
									tableauUserCount
								)} & Last Month: ${formatNumberWithCommas(tableauPrevUserCount)}`}
								renderTooltip={(label) => renderTooltipIcon(label, 'light')}
								number={tableauUsersGrowth ? formatNumberWithCommas(tableauUsersGrowth.toFixed(2), true) : 0}
								bgColor='#ffffff'
								valueFontWeight={300}
								sameDecimalSize={true}
								isLoading={tableauUserCount === null || tableauPrevUserCount === null || tableauUsersGrowth === null}
								units="%"
								handleEvent={() =>
									handleSetComponent('TABLEAU_USER_GROWTH', {
										title: 'Tableau Trend',
										sector: [],
										selectedDate: '0M'
									})
								}
								// bgColor={
								// 	!!tableauUsersGrowth && formatNumberWithCommas(tableauUsersGrowth.toFixed(2), true) !== '0.00'
								// 		? tableauUsersGrowth < 0
								// 			? 'success.main'
								// 			: 'error.main'
								// 		: undefined
								// }
								// unitIcon={
								// 	!!tableauUsersGrowth && formatNumberWithCommas(tableauUsersGrowth.toFixed(2), true) !== '0.00'
								// 		? tableauUsersGrowth > 0
								// 			? ArrowUp
								// 			: ArrowDown
								// 		: null
								// }
								color={getGrowthColor(tableauUsersGrowth, true)}
								unitIcon={getGrowthIcon(tableauUsersGrowth, ArrowIconUpRed, ArrowIconDownGreen)}
								sectorLabel={getSectorLabel('tableauUserGrowth')}
							/>
						</Grid>
					</WidgetCardContainer>
				</Grid>

				<Grid container item xs={12} lg={6} xl={6}>
					<WidgetCardContainer bgColor='#E4EDFF' title="Sustain YTD" titleSx={{fontSize:"24px"}}>
						{/* <Grid item xs={12} sm={4} display="flex">
							<NumberWidget
								title="Major INC Open"
								tooltipLabel="Total D&AI major incidents open"
								number={executiveMetricDetails?.incidentsOpen ?? ''}
								isLoading={!executiveMetricDetails || executiveLoading}
							/>
						</Grid> */}
						<Grid item xs={12} sm={6} display="flex" id="major-inc-ytd">
							<NumberWidget
								title={<HighlightedText text="Major INC YTD" />}
								tooltipLabel="Year to Date D&AI Major INC (Includes Preventive MIMs)"
								renderTooltip={(label) => renderTooltipIcon(label, 'light')}
								number={
									sectorTagList?.majorInc
										? executiveMetricDetails === null ? 1 : executiveMetricDetails?.incidentOpenedLastMonth
										:
										allSectorExecutiveData?.incidentOpenedLastMonth}
								bgColor='#ffffff'
								color='#000000'
								valueFontWeight={300}
								sameDecimalSize={true}
								isLoading={!executiveMetricDetails || executiveLoading}
								handleEvent={handleNavigateIncident}
								sectorLabel={getSectorLabel('majorInc')}
							// handleEvent={() => handleSetComponent('MAJOR_INCIDENTS_LAST_MONTH', {
							// 	title: 'Major INC Open',
							// 	sector: [],
							// 	selectedDate: "2023-01",
							// })}
							/>
						</Grid>
						<Grid item xs={12} sm={6} display="flex" id="platform-outages">
							<NumberWidget
								title={<HighlightedText text="Outages YTD" />}
								tooltipLabel="Year to date D&AI Outages"
								renderTooltip={(label) => renderTooltipIcon(label, 'light')}
								number={sectorTagList?.majorInc
									? executiveMetricDetails === null ? 1 : executiveMetricDetails?.outage
									: allSectorExecutiveData?.outage}
								bgColor='#ffffff'
								color='#000000'
								valueFontWeight={300}
								sameDecimalSize={true}
								isLoading={!executiveMetricDetails || executiveLoading}
								footer={{
									footerLabel: 'Click to look at processing breakdown',
									footerLink: '/dataestate/service-request'
								}}
								handleEvent={() =>
									handleSetComponent('OUTAGES', {
										title: 'Platform Outages YTD',
										sector: [],
										selectedDate: '2023-01'
									})
								}
								sectorLabel={getSectorLabel('majorInc')}
							/>
						</Grid>
						<Grid item xs={12} display="flex" id="unplanned-dt">
							<NumberWidget
								title={<HighlightedText text="Unplanned Platform Downtime" />}
								tooltipLabel="Year to date unplanned Downtime"
								renderTooltip={(label) => renderTooltipIcon(label, 'light')}
								number={
									sectorTagList?.majorInc
										? OutageDuration === null ? '' : [OutageDuration.Days, OutageDuration.Hours, OutageDuration.Minutes]
										: [allSectorExecutiveData?.outageDuration.Days, allSectorExecutiveData?.outageDuration.Hours, allSectorExecutiveData?.outageDuration.Minutes]
								}
								bgColor='#ffffff'
								color='#000000'
								valueFontWeight={300}
								sameDecimalSize={true}
								isLoading={!OutageDuration || executiveLoading}
								units={OutageDuration === null ? null : ['  Days ', ' Hrs ', ' Mins ']}
								// handleEvent={handleNavigateService}
								footer={{
									footerLabel: 'Click to look at processing breakdown',
									footerLink: '/dataestate/service-request'
								}}
								handleEvent={() =>
									handleSetComponent('UNPLANNED_DOWNTIME', {
										title: 'Unplanned Platform Downtime YTD',
										sector: [],
										selectedDate: '2023-01'
									})
								}
								sectorLabel={getSectorLabel('majorInc')}
							/>
						</Grid>
					</WidgetCardContainer>
				</Grid>
			</Grid>
		</PageWrapper>
	);
};

export default OverallSummary;
